import React, { FC } from 'react';
import ProductDetailCover from '../../../shared/product/detail/ProductDetailCover';
import ProductDetailShortInfo from '../../../shared/product/detail/ProductDetailShortInfo';
import ProductDetailExtendedInfo from '../../../shared/product/detail/ProductDetailExtendedInfo';
import ProductDetailStatistics from '../../../shared/product/detail/ProductDetailStatistics';
import ProductDetailSidebar from '../../../shared/product/detail/ProductDetailSidebar';
import ProductDetailLayout from '../../../shared/product/detail/ProductDetailLayout';
import { ShopProduct } from '../../../../models/Product';
import { AppDispatch } from '../../../store';
import { ForeignLanguageProductDetailProductGroups } from '../../../shared/product/detail/ProductDetailProductGroups';
import { SingleAddOptions } from '../../../../models/ListContentCheckOptions';

const handleSelectPrice = async () => {
    // not supported within the catalogue
};

type Props = {
    readonly product: ShopProduct;
    readonly onAddPrice?: (options: SingleAddOptions) => Promise<void>;
    readonly dispatch: AppDispatch;
    readonly shopLanguage: string | undefined;
};

const ForeignLanguageProductDetailView: FC<Props> = props => {
    const { product, onAddPrice = async () => {}, shopLanguage } = props;

    if (!product.id) {
        return null;
    }

    const productDetailCover = <ProductDetailCover product={product} />;
    const productDetailShortInfo = <ProductDetailShortInfo product={product} />;
    const productDetailExtendedInfo = <ProductDetailExtendedInfo product={product} />;
    const productDetailStatistics = <ProductDetailStatistics product={product} />;
    const productDetailSidebar = (
        <ProductDetailSidebar {...props} onAddPrice={onAddPrice} onSelectPrice={handleSelectPrice} />
    );
    const productGroups = <ForeignLanguageProductDetailProductGroups product={product} shopLanguage={shopLanguage} />;

    return (
        <ProductDetailLayout
            pageTitle={product.title!}
            cover={productDetailCover}
            shortInfo={productDetailShortInfo}
            statistics={productDetailStatistics}
            extendedInfo={productDetailExtendedInfo}
            sidebar={productDetailSidebar}
            bottom={productGroups}
        />
    );
};

export default ForeignLanguageProductDetailView;
